import { Route } from '@angular/router';
import { environment } from '@env';

export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [],
    loadChildren: () => import('@gac/feature/dashboard').then((m) => m.dashboardRoutes),
    data: {
      version: environment.version,
    },
  },
  {
    path: '**',
    redirectTo: 'pilotageaccordscommerciaux',
  },
];
